import './DeleteSubscription.scss'

type DeleteActionLabels = {
  buttonType: 'delete'
  buttonLabel?: string
  confirmTitle?: string
  confirmDescription?: string
  confirmYesLabel?: string
  confirmNoLabel?: string
}

type Props = {
  isOpen: boolean
  onConfirm: () => void
  onDismiss: () => void
  subscriptionLabels?: DeleteActionLabels
}

export function DeleteSubscription({ isOpen, onConfirm, onDismiss, subscriptionLabels }: Readonly<Props>) {
  if (!isOpen) {
    return null
  }

  return (
    <div className="delete-subscription-overlay" role="dialog" aria-modal="true" aria-labelledby="delete-subscription-title">
      <div className="delete-subscription-modal">
        <div className="delete-subscription-modal__header">
          <h3 id="delete-subscription-title" className="delete-subscription-modal__title">
            {subscriptionLabels?.confirmTitle}
          </h3>
          <button type="button" className="delete-subscription-modal__close" onClick={onDismiss} aria-label="Close">
            &#x2715;
          </button>
        </div>
        <p className="delete-subscription-modal__subtext">{subscriptionLabels?.confirmDescription}</p>
        <div className="delete-subscription-modal__footer">
          <button type="button" className="delete-subscription-modal__btn delete-subscription-modal__btn--no" onClick={onDismiss}>
            {subscriptionLabels?.confirmNoLabel}
          </button>
          <button type="button" className="delete-subscription-modal__btn delete-subscription-modal__btn--yes" onClick={onConfirm}>
            {subscriptionLabels?.confirmYesLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
